(function () {
  var backdrop = document.querySelector('[data-drawer-backdrop]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = document.querySelector('[data-search-input]');

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openMenu() {
    drawer.classList.add('open');
    backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  }
  function closeMenu() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }
  function openSearch() {
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    if (searchInput) searchInput.focus();
  }
  function closeSearch() {
    searchPanel.classList.remove('open');
    searchPanel.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) openMenu();
    if (e.target.closest('[data-menu-close]')) closeMenu();
    if (e.target.closest('[data-drawer-backdrop]')) closeMenu();
    if (e.target.closest('[data-search-open]')) openSearch();
    if (e.target.closest('[data-search-close]')) closeSearch();
    if (drawer && drawer.classList.contains('open') && e.target.closest('.menu-drawer nav a')) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeSearch(); }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      openSearch();
    }
  });

  document.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var rail = document.querySelector(btn.getAttribute('data-rail-target'));
      if (!rail) return;
      var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
      rail.scrollBy({ left: dir * Math.min(window.innerWidth * 0.78, 920), behavior: 'smooth' });
    });
  });
})();
